import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M1.529 26H30.47c-.728 1.58-2.164 3.74-4.814 4.77-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C3.693 29.74 2.257 27.58 1.53 26M.091 13H31.92c.069 1.036.09 2.048.078 3.016.012.953-.014 1.955-.088 2.984H.083a37 37 0 0 1-.08-3.017A35 35 0 0 1 .091 13m30.398-7H1.529c.727-1.58 2.164-3.741 4.813-4.77C8.433.431 12.25.032 16 0c3.75.033 7.567.432 9.69 1.263 2.632 1.022 4.067 3.16 4.8 4.737",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M3.308 28.692C1.39 26.63.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .524-2.505 2.441-4.568L16 16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M5.667 18.067 3.12 19.839l.898-2.97-2.473-1.875 3.103-.063L5.667 12l1.018 2.931 3.103.063-2.473 1.875.899 2.97z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCub = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCub_default = SvgFlagCub;

export { FlagCub_default as default };
